module.exports = __webpack_public_path__ + "static/media/icon_shujuanquan.dce00734.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/pageLargeModelSecurity/icon_shujuanquan.svg
// module id = 620
// module chunks = 0